module.exports = __webpack_public_path__ + "static/media/4 Seats 5 Sides Outdoor (connected).585700ec.png";